import { Switch, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { tokens } from "./tokens";

interface Props {
    label: string;
    description?: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
}

const useStyles = makeStyles(() => ({
    row: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "16px",
        padding: "13px 0",
        borderBottom: `1px solid ${tokens.line}`,
        "&:last-child": {
            borderBottom: "none",
        },
    },
    label: {
        fontSize: "13.5px",
        fontWeight: 500,
        color: tokens.ink,
        display: "block",
    },
    description: {
        fontSize: "12.5px",
        color: tokens.hint,
    },
}));

export const SwitchRow: React.FC<Props> = ({ label, description, checked, onChange, disabled }) => {
    const classes = useStyles();

    return (
        <div className={classes.row}>
            <div>
                <Typography component="b" className={classes.label}>{label}</Typography>
                {description && <Typography component="span" className={classes.description}>{description}</Typography>}
            </div>
            <Switch
                color="primary"
                checked={checked}
                onChange={(event) => onChange(event.target.checked)}
                disabled={disabled}
            />
        </div>
    );
};
